import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import HouseholdSectionMember from './HouseholdSectionMember';


const HouseholdSectionMemberContainer = ({
  relationshipLink,
}) => {
  const {
    isInitializing, loadingError, collection,
  } = useLink(relationshipLink);

  return (
    <DataContainer
      component={HouseholdSectionMember}
      loading={isInitializing}
      loadingError={loadingError}
      componentProps={{
        collection,
      }}
    />
  );
};

HouseholdSectionMemberContainer.propTypes = {
  relationshipLink: PropTypes.object.isRequired,
};

export default HouseholdSectionMemberContainer;
